import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "./Mockinterviewmarksupdate.module.css";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import { AxiosInstance } from "../../../../../axios";

const MockInterviewMarksUpdate = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    studentId = "",
    interview_id = null,
    panel_id = null,
    ADMISSION_ID = null,
    STAFFID = "",
  } = state || {};
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let staff_id = null;
  if (userJSON) {
    try {
      const user = JSON.parse(userJSON);
      userid = user?.user_id || "";
      staff_id = STAFFID || user?.id || "";
    } catch (error) {
      console.error("Invalid userDetails in sessionStorage", error);
    }
  } else {
    console.warn("User details not available in sessionStorage");
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  const [editId, setEditId] = useState("");
  // Comments state
  const [comments, setComments] = useState("");
  const [commentsError, setCommentsError] = useState("");
  // Form submission attempted state
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  // Loading state
  const [isLoading, setIsLoading] = useState(false);
  // Attendance state - default is "present" (1 for present, 0 for absent)
  const [attendance, setAttendance] = useState("present");
  // Marks criteria data with API field mapping
  const [marksCriteria, setMarksCriteria] = useState([
    {
      id: 1,
      criteria: "Personality",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "personality",
    },
    {
      id: 2,
      criteria: "General Knowledge",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "general_knowledge",
    },
    {
      id: 3,
      criteria: "Departmental Knowledge",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "departmental_knowledge",
    },
    {
      id: 4,
      criteria: "Core Subject Knowledge",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "core_subject",
    },
    {
      id: 5,
      criteria: "Habit of Reading",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "habit",
    },
    {
      id: 6,
      criteria: "Leadership Quality",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "leadership",
    },
    {
      id: 7,
      criteria: "Communication Skills",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "communication",
    },
    {
      id: 8,
      criteria: "Problem Solving and Decision Making",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "problem_solving",
    },
    {
      id: 9,
      criteria: "Logical and Analytical Skill",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "logical_skill",
    },
    {
      id: 10,
      criteria: "Computer Proficiency",
      maxMark: 10,
      obtainedMark: "",
      error: "",
      apiField: "computer_proficiency",
    },
  ]);
  const isAnyMarkEntered = marksCriteria.some(
    (item) => item.obtainedMark !== ""
  );
  // Fetch existing marks data on component mount (if editing)
  useEffect(() => {
    fetchExistingMarks();
  }, []);

  // Fetch existing marks from API
  const fetchExistingMarks = async () => {
    setIsLoading(true);
    try {
      const response = await AxiosInstance.post(
        `api/mockinterview/interview/view_marks`,
        {
          user_id: studentId,
          interview_id: interview_id,
          panel_id: panel_id,
          staff_id: staff_id,
        }
      );

      if (response?.data?.status === true) {
        const staffMarks = response.data.staffMarks || [];

        // Find marks given by current staff
        const matchedStaff = staffMarks.find(
          (staff) => Number(staff.staff_id) === Number(staff_id)
        );
        setEditId(matchedStaff?.id || "");
        if (matchedStaff) {
          // Update marksCriteria using apiField mapping
          setMarksCriteria((prev) =>
            prev.map((item) => ({
              ...item,
              obtainedMark:
                matchedStaff[item.apiField] !== undefined
                  ? String(matchedStaff[item.apiField])
                  : "",
              error: "",
            }))
          );

          // Set comments
          setComments(matchedStaff.comments || "");
        }
      }
    } catch (error) {
      console.error("Error fetching marks:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Validate marks on attendance change
  useEffect(() => {
    if (isSubmitAttempted) {
      validateAllFields();
    }
  }, [attendance]);

  // Handle attendance change
  const handleAttendanceChange = (value) => {
    setAttendance(value);

    // Clear errors if changing to absent
    if (value === "absent") {
      setMarksCriteria([
        {
          id: 1,
          criteria: "Personality",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "personality",
        },
        {
          id: 2,
          criteria: "General Knowledge",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "general_knowledge",
        },
        {
          id: 3,
          criteria: "Departmental Knowledge",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "departmental_knowledge",
        },
        {
          id: 4,
          criteria: "Core Subject Knowledge",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "core_subject",
        },
        {
          id: 5,
          criteria: "Habit of Reading",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "habit",
        },
        {
          id: 6,
          criteria: "Leadership Quality",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "leadership",
        },
        {
          id: 7,
          criteria: "Communication Skills",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "communication",
        },
        {
          id: 8,
          criteria: "Problem Solving and Decision Making",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "problem_solving",
        },
        {
          id: 9,
          criteria: "Logical and Analytical Skill",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "logical_skill",
        },
        {
          id: 10,
          criteria: "Computer Proficiency",
          maxMark: 10,
          obtainedMark: "",
          error: "",
          apiField: "computer_proficiency",
        },
      ]);
      setComments("");
      setCommentsError("");
    }
  };

  // Handle obtained mark change
  const handleMarkChange = (id, value) => {
    // Allow only numbers and limit to 2 digits
    const numericValue = value.replace(/[^0-9]/g, "").slice(0, 2);

    setMarksCriteria((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          let error = "";

          // Validate if value exceeds maximum mark
          if (numericValue !== "" && parseInt(numericValue) > item.maxMark) {
            error = `Mark cannot exceed ${item.maxMark}`;
          }

          return { ...item, obtainedMark: numericValue, error };
        }
        return item;
      })
    );
  };

  // Handle comments change
  const handleCommentsChange = (value) => {
    setComments(value);
    if (value.trim() !== "") {
      setCommentsError("");
    }
  };

  // Validate all fields
  const validateAllFields = () => {
    let isValid = true;

    // If attendance is present, validate marks and comments
    if (attendance === "present") {
      // Validate marks
      const updatedMarks = marksCriteria.map((item) => {
        let error = "";

        if (item.obtainedMark === "") {
          error = "This field is required";
          isValid = false;
        } else if (parseInt(item.obtainedMark) > item.maxMark) {
          error = `Mark cannot exceed ${item.maxMark}`;
          isValid = false;
        }

        return { ...item, error };
      });

      setMarksCriteria(updatedMarks);

      // Validate comments
      if (comments.trim() === "") {
        setCommentsError("Comments are required");
        isValid = false;
      } else {
        setCommentsError("");
      }
    }

    return isValid;
  };

  // Handle form submission
  const handleSaveMarks = async () => {
    setIsSubmitAttempted(true);

    const isValid = validateAllFields();

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    try {
      // Build the marks object dynamically from marksCriteria
      const marksData = {};
      marksCriteria.forEach((item) => {
        marksData[item.apiField] =
          attendance === "present" ? parseInt(item.obtainedMark) || 0 : 0;
      });

      // Prepare data for API
      const requestData = {
        // id: studentData?.id || null,
        attendance_status: attendance === "present" ? 1 : 0,
        ...marksData,
        comments: attendance === "present" ? comments : "",
        id: editId || "",
        user_id: studentId,
        interview_id: interview_id,
        panel_id: panel_id,
        staff_id: staff_id,
        created_by: userid,
      };

      // API call
      const response = await AxiosInstance.post(
        "api/mockinterview/interview/update_marks",
        requestData
      );

      if (response.data.status) {
        toast.success(response.data.message || "Marks updated successfully!");
        // Navigate back to student view
        navigate(-1);
      } else {
        toast.error(
          response.data.message || "Failed to update marks. Please try again."
        );
      }
    } catch (error) {
      console.error("Error saving marks:", error);
      toast.error(
        error.response?.data?.message || "Error saving marks. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle back to student view
  const handleBackToStudent = () => {
    navigate(-1);
    // navigate(`/ViewStudentDetails/${studentId}`, {
    //   state: {
    //     ADMISSION_ID: ADMISSION_ID,
    //   },
    // });
  };

  return (
    <div className={`container-fluid  p-0 global_container BathHeader`}>
      <div className={styles.bathHeader}>
        {/* Header */}
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className={styles.titleHeader}>Update Marks</h2>
          </div>
          <div className={`col-md-6 col-12 ${styles.listBtn}`}>
            <ul className={styles.listButton}>
              <li className={styles.listBtnItems}>
                <Link
                  // to="#"
                  onClick={handleBackToStudent}
                  // onClick={() =>
                  //   navigate("/Viewpanel", {
                  //     state: {
                  //       PANELID: panel_id,
                  //     },
                  //   })
                  // }
                  // className={styles.secondaryButton}
                  className="secondaryButton "
                  variant="primary"
                >
                  Back to View Student
                </Link>
              </li>
              <li className={styles.listBtnItems}>
                <button
                  type="button"
                  onClick={handleSaveMarks}
                  className={styles.primaryButton}
                >
                  Save Marks
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Attendance Section */}
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Attendance</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-6 col-md-6 col-12">
                <div className="d-flex flex-column">
                  <p className={styles.confirmLabel}>Attendance</p>
                  <div className={styles.radioGroup}>
                    <label className={styles.radioLabel}>
                      <input
                        type="radio"
                        name="attendance"
                        value="present"
                        checked={attendance === "present"}
                        onChange={(e) => handleAttendanceChange(e.target.value)}
                        className={styles.radioInput}
                      />
                      <span className={styles.radioCustom}></span>
                      Present
                    </label>
                    <label className={styles.radioLabel}>
                      <input
                        type="radio"
                        name="attendance"
                        value="absent"
                        checked={attendance === "absent"}
                        onChange={(e) => handleAttendanceChange(e.target.value)}
                        className={styles.radioInput}
                        disabled={isAnyMarkEntered}
                      />
                      <span className={styles.radioCustom}></span>
                      Absent
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        {/* Marks Table Section */}
        <fieldset className="mt-3">
          <legend className="w-auto">Marks</legend>
          <div className="row mx-0 mt-2">
            <div className="col-md-12 table-responsive px-0">
              <table
                className={`table ${styles.marksTable}`}
                id="tableListHeader"
              >
                <thead>
                  <tr className={styles.tableHeader}>
                    <th className={styles.thSno}>S.No</th>
                    <th className={styles.thCriteria}>Criteria</th>
                    <th className={styles.thMaxMark}>Maximum Mark</th>
                    <th className={styles.thObtainedMark}>Obtained Mark</th>
                  </tr>
                </thead>
                <tbody>
                  {marksCriteria.map((item) => (
                    <tr key={item.id} className={styles.tableRow}>
                      <td className={styles.tdSno}>{item.id}</td>
                      <td className={styles.tdCriteria}>{item.criteria}</td>
                      <td className={styles.tdMaxMark}>{item.maxMark}</td>
                      <td className={styles.tdObtainedMark}>
                        <div className={styles.inputWrapper}>
                          <input
                            type="text"
                            value={item.obtainedMark}
                            onChange={(e) =>
                              handleMarkChange(item.id, e.target.value)
                            }
                            className={`${styles.markInput} ${
                              item.error ? styles.inputError : ""
                            } w-100 rounded-2 input-font-size-sm`}
                            placeholder=""
                            disabled={attendance === "absent"}
                            maxLength={2}
                          />
                          {item.error && (
                            <small className={styles.errorMessage}>
                              {item.error}
                            </small>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>

        {/* Comments Section */}
        <fieldset className="mt-3">
          <legend className="w-auto">Comments</legend>
          <div className="row mb-3">
            <div className="my-1 col-12">
              <div className="d-flex flex-column">
                <p className={styles.confirmLabel}>Comments</p>
                <div className={styles.textareaWrapper}>
                  <textarea
                    value={comments}
                    onChange={(e) => handleCommentsChange(e.target.value)}
                    className={`${styles.commentsTextarea} ${
                      commentsError ? styles.inputError : ""
                    }`}
                    placeholder="Enter Comments"
                    rows={4}
                    disabled={attendance === "absent"}
                  />
                  {commentsError && (
                    <small className={styles.errorMessage}>
                      {commentsError}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        {/* Footer Buttons */}
        <div className={styles.footerButtons}>
          <Link
            // to="#"
            onClick={handleBackToStudent}
            // className={styles.secondaryButton}
            className="secondaryButton "
            variant="primary"
          >
            Back to View Student
          </Link>
          <button
            type="button"
            onClick={handleSaveMarks}
            className={styles.primaryButton}
          >
            Save Marks
          </button>
        </div>
      </div>

      {/* Loader */}
      {isLoading && (
        <div
          className={styles.loaderApi}
          style={{
            display: isLoading ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            zIndex: 999,
          }}
        >
          <Loader />
        </div>
      )}
    </div>
  );
};

export default MockInterviewMarksUpdate;
